"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProductLogo = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styles = require("@material-ui/core/styles");

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../../../Button"));

var _Typography = _interopRequireDefault(require("../../../Typography"));

var _OrganizationHelper = require("../../../Utilities/OrganizationHelper");

var _ThemeHelper = require("../../../Utilities/ThemeHelper");

var _styles2 = require("./styles");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var WrappedImage = function WrappedImage(props) {
  var branding = props.branding,
      orgName = props.orgName,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["branding", "orgName"]);
  return branding.organizationWebsite ? /*#__PURE__*/_react.default.createElement("a", {
    href: branding.organizationWebsite,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({}, otherProps, {
    alt: orgName + " main website"
  }))) : /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({}, otherProps, {
    alt: orgName + " logo"
  }));
};

WrappedImage.propTypes = {
  branding: _propTypes.default.shape({
    organizationWebsite: _propTypes.default.string
  }),
  orgName: _propTypes.default.string
};

var ProductLogo = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductLogo, _Component);

  var _super = _createSuper(ProductLogo);

  function ProductLogo() {
    var _this;

    (0, _classCallCheck2.default)(this, ProductLogo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "makeLogo", function (branding, orgName) {
      var _this$props = _this.props,
          classes = _this$props.classes,
          disableSidebar = _this$props.disableSidebar,
          type = _this$props.type;
      return branding.reverseLogo || branding.standardLogo ? /*#__PURE__*/_react.default.createElement(WrappedImage, {
        branding: branding,
        orgName: orgName,
        src: branding.reverseLogo ? branding.reverseLogo : branding.standardLogo,
        className: (0, _classnames.default)(classes.logo, (0, _defineProperty2.default)({}, classes.logoMaxHeight, disableSidebar && type === "external"))
      }) : /*#__PURE__*/_react.default.createElement("span", {
        className: classes.logo
      }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "h6",
        color: "inherit"
      }, orgName));
    });
    return _this;
  }

  (0, _createClass2.default)(ProductLogo, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          id = _this$props2.id,
          classes = _this$props2.classes,
          isOpen = _this$props2.isOpen,
          onClick = _this$props2.onClick,
          type = _this$props2.type,
          currentOrgSettings = _this$props2.currentOrgSettings,
          productLogo = _this$props2.productLogo,
          product = _this$props2.product,
          disableSidebar = _this$props2.disableSidebar;
      var brandedLogo = currentOrgSettings && currentOrgSettings.settings && currentOrgSettings.settings.brandingSettings && this.makeLogo(currentOrgSettings.settings.brandingSettings, (0, _OrganizationHelper.formatOrgName)(currentOrgSettings, this.props.currentOrg));
      var logo = type === "external" && brandedLogo ? brandedLogo : productLogo ? productLogo : product && product in _ThemeHelper.themes ? _ThemeHelper.themes[product].logo : _ThemeHelper.themes.default.logo;
      return (
        /*#__PURE__*/
        // The action is able to be toggled through the Button as well, so disabling rule
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        _react.default.createElement("div", {
          id: id + "-product-logo-container",
          className: (0, _classnames.default)(classes.iconContainer, classes.logoContainer, (0, _defineProperty2.default)({}, classes.canBeClicked, onClick), (0, _defineProperty2.default)({}, classes.logoContainerMaxHeight, disableSidebar && type === "external")),
          onClick: onClick
        }, logo, onClick && /*#__PURE__*/_react.default.createElement(_Button.default, {
          type: "icon",
          onClick: onClick,
          color: "inherit",
          "aria-haspopup": "menu",
          title: isOpen ? "Hide available CivicPlus Platform products" : "Show available CivicPlus Platform products",
          className: (0, _classnames.default)(classes.arrowContainer, (0, _defineProperty2.default)({}, classes.arrowContainerOpen, isOpen))
        }, /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null)))
      );
    }
  }]);
  return ProductLogo;
}(_react.Component);

exports.ProductLogo = ProductLogo;
(0, _defineProperty2.default)(ProductLogo, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * @ignore
   *
   * Utilizing this to pass styles from Page component
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The html node to render as the product logo
   */
  children: _propTypes.default.node,

  /**
   * The onlick function to add to the product logo
   */
  onClick: _propTypes.default.func,

  /**
   * Whether or not the product menu is open or not
   */
  isOpen: _propTypes.default.bool,

  /**
   * The current organization's name
   */
  currentOrg: _propTypes.default.string,

  /**
   * The current organization's branding settings
   */
  currentOrgSettings: _propTypes.default.shape({
    name: _propTypes.default.string,
    id: _propTypes.default.string,
    settings: _propTypes.default.object
  }),

  /**
   * Sets product colors and logo automatically. Can be overridden by primaryHex and productLogo
   */
  product: _propTypes.default.oneOf(Object.keys(_ThemeHelper.themes)),

  /**
   * The type of page, which affects what logo and color is used
   */
  type: _propTypes.default.oneOf(["internal", "external"]),

  /**
   * The html node to render as the product logo
   */
  productLogo: _propTypes.default.node,

  /**
   * If `true` the side bar will not be displayed
   */
  disableSidebar: _propTypes.default.bool
});

var _default = (0, _styles.withStyles)(_styles2.styles)(ProductLogo);

exports.default = _default;